import { SetAuthTokenToStore, ValidateAuthTokenSuccess } from '@biz-action/system-actions/auth-token.actions';
import { authenticationAccount } from '@biz-action/user-actions/account-actions';
import { authentication } from '@biz-action/user-actions/auth-login.actions';
import { LinkASubdomain } from '@biz-action/user-actions/link-an-account.actions';
import { AuthTokenState } from '@biz-store/auth/states/auth-token.state';
import { createReducer, on } from '@ngrx/store';
// import { SetAuthToken, SetAuthTokenL4, ValidateAuthTokenSuccess } from '@biz-action/app.actions';

const initialState: AuthTokenState = {
	isAuthenticated: false,
	l7: '',
	loginResp: undefined,
	isLoading: false,
	currentSubdomain: '',
	onLinking: false,
	linkingIndex: null,
};

export const reducer = createReducer(
	initialState,
	on(SetAuthTokenToStore, (state, action) => {
		state = { ...state, l7: action.payload.token };
		return state;
	}),
	on(ValidateAuthTokenSuccess, (state) => {
		state = { ...state, isAuthenticated: true, isLoading: false };
		return state;
	}),
	on(authentication.logininit, (state) => {
		state = { ...state, isLoading: true, onLinking: false };
		return state;
	}),
	on(authentication.settingslogininit, (state) => ({
		...state,
		isLoading: true,
		onLinking: true,
		linkingIndex: null,
	})),
	on(LinkASubdomain, (state, action) => ({
		...state,
		linkingIndex: state.loginResp.findIndex((i) => i.subdomain === action.payload.subdomain),
	})),
	on(authentication.loginsuccess, authentication.settingloginsuccess, (state, action) => {
		state = {
			...state,
			loginResp: action.payload,
			isLoading: false,
			isAuthenticated: true,
			currentSubdomain: action.payload[0]?.subdomain,
		};
		return state;
	}),
	on(authentication.loginfail, (state) => {
		state = { ...state, isLoading: false };
		return state;
	}),

	on(authenticationAccount.changepassword, (state) => {
		state = { ...state, isLoading: true };
		return state;
	}),

	on(authenticationAccount.changepasswordsuccess, (state) => {
		state = { ...state, isLoading: false };
		return state;
	}),

	on(authenticationAccount.changepasswordfail, (state) => {
		state = { ...state, isLoading: false };
		return state;
	}),

	on(authentication.logoutaccount, (state) => ({
		...initialState,
		currentSubdomain: state.currentSubdomain,
	})),

	// on(SetAuthTokenL4, (state, action) => {
	// 	state = { ...state, l4: action.payload.token };
	// 	return state;
	// }),
);
